/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramGeoControllerSearchQueryResponse,
  TelegramGeoControllerSearchQueryParams,
} from '../types/TelegramGeoControllerSearch.ts';

function getTelegramGeoSearchUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo/search` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/search}
 */
export async function telegramGeoSearch(
  params: TelegramGeoControllerSearchQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerSearchQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoSearchUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
